import {usePlantConfig} from '@domain/shifthandover'
import {UseMutationResult} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {
  CreateMachineSentryMaintenanceNotificationActionDto,
  MachineSentryActionDto
} from '../../types'

import {MachineSentryCreateMaintenanceNotificationDialogContent} from './MachineSentryCreateMaintenanceNotificationDialogContent'

type MachineSentryCreateMaintenanceNotificationDialogProps = {
  event: MachineSentryActionDto
  plantId: string
  showDialog: boolean
  setDialog: (state: boolean) => void
  createNotification: UseMutationResult<
    string,
    AxiosError,
    CreateMachineSentryMaintenanceNotificationActionDto
  >
}

export const MachineSentryCreateMaintenanceNotificationDialog: React.FC<
  MachineSentryCreateMaintenanceNotificationDialogProps
> = ({event, plantId, setDialog, createNotification: createNotificationProp}) => {
  const createNotification = (
    notification: CreateMachineSentryMaintenanceNotificationActionDto
  ) => {
    createNotificationProp.mutate({
      ...notification
    })
    setDialog(false)
  }

  const {i18n} = useTranslation(FEATURE_NAMESPACE)
  const {data} = usePlantConfig({plantId, language: i18n.language})

  if (!data) {
    return null
  }

  return (
    <MachineSentryCreateMaintenanceNotificationDialogContent
      onClose={() => {
        setDialog(false)
      }}
      plantId={data.plantId}
      workCenters={data.workCenters}
      open={true}
      onConfirm={createNotification}
      event={event}
    />
  )
}
